<template>
  <div class="loading"></div>
</template>

<script>
import Auth from "@/util/auth.js";

export default {
  mounted() {
    this.getAuthInfo();
  },
  methods: {
    /**
     * 检查身份信息
     */
    getAuthInfo() {
      var me = this,
        token = me.$route.query.token;
      if (token) {
        // 有传统一ssotoken过来
        me.getAuthInfoByToken(token);
      } else {
        // 否则，判断当前页面是否有登录信息。未登录则跳转登录
        Auth.get()
          .then(function (info) {
            me.redirectApp(info);
          })
          .catch(() => {
            me.redirectLogin();
          });
      }
    },
    /**
     * 使用ssotoken检查身份信息
     */
    getAuthInfoByToken(token) {
      var me = this;
      me.$ajax({
        url: "/api/auth/sso/authorize_token",
        params: {
          token,
        },
      }).then(function (res) {
        if (res.success) {
          var authData = res.data;
          if (authData.unauthorized) {
            // 出现该情况是从sso登录的企业，还未开通saas应用，需要提醒用户开通
            me.redirectRegister(authData.account, authData.unauthorized);
          } else if (!authData.companyId) {
            // 出现该情况是从sso以个人身份登录，需要提醒用户切换或注册企业
            me.applyAppFromSso(authData.account);
          } else {
            Auth.set(authData);
            me.redirectApp(authData);
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function () {
            me.redirectLogin();
          }, 3000);
        }
      });
    },
    redirectApp(authData) {
      var page = this.$route.query.page, portal = this.$route.query.portal;
      if (page && page.indexOf('https') == 0) {
        window.location.href = page;
      } else {
        if (!page) {
          // portal = b2b/process/report/profile
          page = "/" + authData.appId.replace("-app", "") + (portal ? ('/' + portal) : '');
        }
        this.$router.replace(page);
      }
    },
    redirectLogin() {
      this.$router.replace("/login" + window.location.search);
    },
    /**
     * 选择需要开通saas的企业(sso中绑定的企业)
     */
    applyAppFromSso(account) {
      const me = this;
      me.getSsoCompanies(account.mobile).then(function (companies) {
        if (companies && companies.length) {
          if (companies.length == 1) {
            me.redirectRegister(account, companies[0]);
          } else {
            let items = companies.map((c) => {
              return {
                label: c.name,
                value: c,
              };
            });
            me.$weui.picker(items, {
              title: "选择公司，开通云系统",
              onConfirm: function (result) {
                me.redirectRegister(account, result[0]);
              },
            });
          }
        } else {
          me.$weui.topTips(
            "您的账号还未绑定企业，请先注册或找您的企业管理员绑定账号！",
            3000
          );
          setTimeout(function () {
            me.$router.replace("/register");
          }, 3000);
        }
      });
    },
    /**
     * 查找sso中绑定的企业
     */
    getSsoCompanies(mobile) {
      const me = this;
      return me
        .$ajax({
          url: "/api/account/account/sso_companies",
          params: {
            mobile,
          },
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
    },
    /**
     * 跳转开通企业应用
     */
    redirectRegister(account, company) {
      this.$router.replace({
        name: "AutoRegister",
        params: {
          signInfo: {
            mobile: account.mobile,
            userName: account.realname,
            companyName: company.name,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -80px 0 0 -40px;
  width: 80px;
  height: 80px;
  border: 3px solid #d0d3d4;
  border-top-color: #626567;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>